import { render, staticRenderFns } from "./MatrixBlockCustomerStoryContent.vue?vue&type=template&id=6d2bfb9e"
import script from "./MatrixBlockCustomerStoryContent.vue?vue&type=script&lang=js"
export * from "./MatrixBlockCustomerStoryContent.vue?vue&type=script&lang=js"
import style0 from "./MatrixBlockCustomerStoryContent.vue?vue&type=style&index=0&id=6d2bfb9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports